import React from 'react'
import { Order } from '../../../types/orderTypes'
import { OrderItem } from './OrderItem'

interface OrderPackageProp{
order:Order
}
export const OrderPackage:React.FC<OrderPackageProp> = ({order}) => {


  return (
    <div  style={{marginBottom:"2rem"}} className=' bg-[#DAE0E2]  space-y-2 rounded-md cursor-pointer '>
        <div className="flex pl-5 pt-5 text-bold">
        

        </div>
     
        {order.items.map((item,index)=><OrderItem item={item} order={order} key={index} />)}
    </div>
  )
}
